/**
 * Layout helper utilities: workspace detection and background class map.
 */

import { type BackgroundStyle } from '@elsapiens/providers'

import { AUTH_ORIGIN } from '../../utils/domain'

export const AUTH_BASE_URL = AUTH_ORIGIN

/** Canvas-based backgrounds — lazy-loaded only when the style is active */
export const CANVAS_IMPORTS: Partial<Record<BackgroundStyle, () => Promise<unknown>>> = {
  waves: () => import('@elsapiens/styles/wave-canvas'),
  fireflies: () => import('@elsapiens/styles/fireflies-canvas'),
  ripples: () => import('@elsapiens/styles/ripples-canvas'),
  silk: () => import('@elsapiens/styles/silk-canvas'),
  origami: () => import('@elsapiens/styles/origami-canvas'),
  snowfall: () => import('@elsapiens/styles/snowfall-canvas'),
  network: () => import('@elsapiens/styles/network-canvas'),
}

/** CSS class mapping for background styles */
export const BACKGROUND_CLASS_MAP: Record<BackgroundStyle, string> = {
  none: '',
  aurora: 'el-bg-aurora',
  mesh: 'el-bg-mesh',
  glow: 'el-bg-glow',
  dots: 'el-bg-dots',
  'gradient-shift': 'el-bg-gradient-shift',
  'northern-lights': 'el-bg-northern-lights',
  particles: 'el-bg-particles',
  waves: 'el-bg-waves',
  blobs: 'el-bg-blobs',
  network: 'el-bg-network',
  origami: 'el-bg-origami',
  snowfall: 'el-bg-snowfall',
  fireflies: 'el-bg-fireflies',
  ripples: 'el-bg-ripples',
  silk: 'el-bg-silk',
}

